module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAAAXNSR0IArs4c6QAAAPlJREFUSEvt1LEOAUEQBuCZbQgnuUqUSomGQqI8nVArdBdPcG/inoB7AC0KEtdJnEIhodErNbqzK5tIJELszOUasfXsfLuzfxY9z1OQ8kKN+L6PaTm6/x8xni5pXK5Ts4NwdzHu/ig0RgbdxhBQtKWUrWAWnSmQEaJvIKzMGgEqCuBIhYwQfWq30ygJIVYcyBhJApEQLkRGOBALeUJ4QEAblNqfrpt6GEL8LnVsREcaUXigIJby1h/Pt5NPsWYhFEDDZIQKkBEOQEK4gDHiOuWssIoLVNj89siJ0tVzqlYhn2uOptGS8jka34Ta9LWenC4O+IMIZwyUPXd9Chzg+g1ooQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/pageright.png
// module id = Q/D4
// module chunks = 1